import { parseZonedDateTime } from '@rematter/common/dateTime';
import {
  AssistantChatStatus,
  enumAssistantChatSortOption,
} from '@rematter/frontend-lib-api-client';

import { assistantChatWithAgentFragment } from './fragmentsAssistantChat';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type ChatRecord = QueryAtomResult<
  typeof aiChatsQueryAtom
>['chats'][number];

export const aiChatsQueryAtom = createQueryAtomFactory(
  'assistant.chats',
  (params: {
    status?: AssistantChatStatus;
    searchTerm?: string;
    pagination?: { limit: number; offset: number };
  }) => ({
    assistantChats: {
      __args: {
        filter: {
          status: params.status,
          searchTerm: params.searchTerm,
        },
        sorting: [enumAssistantChatSortOption.CreatedAtDesc],
        pagination: params.pagination,
      },
      page: { total: true },
      entries: assistantChatWithAgentFragment,
    },
  }),
  {
    select: ({ assistantChats }) => ({
      total: assistantChats.page.total ?? 0,
      chats: assistantChats.entries.map((c) => ({
        ...c,
        createdAt: parseZonedDateTime(c.timestamps.createdAt),
        updatedAt: parseZonedDateTime(c.timestamps.updatedAt),
      })),
    }),
  },
);
